import React, { useState, useRef } from 'react';
import { sendFormJSON } from '../utils/sendForm';
import Notification from './Notification';
import bubbleTeaImage from '../assets/designbubletea.png.avif';
import './Contact.css';
import './ContactHeader.css';

const Contact = () => {
  const [notification, setNotification] = useState({ show: false, type: 'success', title: '', message: '' });
  const formRef = useRef(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await sendFormJSON(e.currentTarget, 'contact');
      if (formRef.current) {
        formRef.current.reset();
      }
      setNotification({
        show: true,
        type: 'success',
        title: 'Message envoyé !',
        message: 'Merci pour votre message ! Nous vous répondrons dans les plus brefs délais.'
      });
      setTimeout(() => {
        setNotification({ show: false, type: 'success', title: '', message: '' });
      }, 8000);
    } catch (err) {
      console.error('Contact send error', err);
      setNotification({
        show: true,
        type: 'error',
        title: 'Erreur lors de l\'envoi',
        message: 'Une erreur est survenue. Veuillez réessayer plus tard.'
      });
    }
  };

  return (
    <section id="contact" className="contact section">
      {/* Background animé */}
      <div className="contact-background">
        {/* Cercles flottants */}
        <div className="floating-circles">
          {[...Array(8)].map((_, i) => (
            <div key={i} className={`floating-circle circle-${i + 1}`}></div>
          ))}
        </div>
        
        {/* Formes géométriques */}
        <div className="geometric-shapes">
          <div className="shape triangle-1"></div>
          <div className="shape square-1"></div>
          <div className="shape triangle-2"></div>
          <div className="shape circle-bg-1"></div>
          <div className="shape square-2"></div>
          <div className="shape triangle-3"></div>
        </div>

        {/* Particules de bubble tea */}
        <div className="contact-particles">
          {[...Array(6)].map((_, i) => (
            <div key={i} className={`contact-particle particle-${i + 1}`}>
              <img src={bubbleTeaImage} alt="" className="particle-image" />
            </div>
          ))}
        </div>
      </div>

      <div className="container">
        <div className="contact-header">
          <h1 className="contact-main-title">Contact</h1>
          <p className="contact-description">
            Découvrez notre Bubble Tea avec des saveurs Smoothie incroyables
          </p>
          <h2 className="section-title">Contactez-nous</h2>
          <p className="section-subtitle">
            Une question ? Une suggestion ? N'hésitez pas à nous écrire !
          </p>
        </div>

        <div className="contact-content contact-form-only">
          {/* Formulaire de contact */}
          <div className="contact-form-container">
            <form ref={formRef} className="contact-form" onSubmit={handleSubmit}>
              <input type="text" name="website" style={{display:'none'}} aria-hidden="true" tabIndex="-1" />
              <h3>Envoyez-nous un message</h3>
              
              <div className="form-row">
                <div className="form-group">
                  <label>Prénom *</label>
                  <input
                    type="text"
                    name="firstName"
                    required
                    className="form-input"
                    placeholder="Votre prénom"
                  />
                </div>
                
                <div className="form-group">
                  <label>Nom *</label>
                  <input
                    type="text"
                    name="lastName"
                    required
                    className="form-input"
                    placeholder="Votre nom"
                  />
                </div>
              </div>

              <div className="form-row">
                <div className="form-group">
                  <label>Email *</label>
                  <input
                    type="email"
                    name="email"
                    required
                    className="form-input"
                    placeholder="votre.email@exemple.com"
                  />
                </div>
                
                <div className="form-group">
                  <label>Sujet *</label>
                  <select 
                    name="subject"
                    required
                    className="form-input"
                  >
                    <option value="">Choisir un sujet</option>
                    <option value="info">Information générale</option>
                    <option value="reservation">Réservation</option>
                    <option value="franchise">Franchise</option>
                    <option value="event">Événement privé</option>
                    <option value="other">Autre</option>
                  </select>
                </div>
              </div>

              <div className="form-group">
                <label>Message *</label>
                <textarea
                  name="message"
                  required
                  className="form-input"
                  rows="6"
                  placeholder="Votre message..."
                ></textarea>
              </div>

              <button type="submit" className="btn btn-primary contact-btn">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M2.01 21L23 12L2.01 3L2 10L17 12L2 14L2.01 21Z" fill="currentColor"/>
                </svg>
                Envoyer le message
              </button>
            </form>
          </div>
        </div>
      </div>
      
      <Notification
        show={notification.show}
        type={notification.type}
        title={notification.title}
        message={notification.message}
        onClose={() => setNotification({ show: false, type: 'success', title: '', message: '' })}
      />
    </section>
  );
};

export default Contact;